module.exports = __webpack_public_path__ + "images/notifications-icons.56f961e.svg";